import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { errorMessage } from '~/utils/utils';
import { useUserStore } from '~/store/user';
import { useAppStore } from '~/store/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'BImpersonated',
  props: {
    hasMaxWidth: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Number,
      default: 0
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var appStore = useAppStore();
    var userStore = useUserStore();
    var sdk = useSdk();
    var services = useServices();
    var notifier = useNotifier();
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useFeatureFlags = useFeatureFlags(),
      mainOrganizer = _useFeatureFlags.mainOrganizer;
    var canAccessDashboard = computed(function () {
      return userStore.canAccessDashboard;
    });
    var getUser = computed(function () {
      return userStore.getUser;
    });
    var impersonatedUser = computed(function () {
      var _user$firstName;
      var user = getUser.value;
      if (!user) return '';
      return ((_user$firstName = user.firstName) === null || _user$firstName === void 0 ? void 0 : _user$firstName.length) > 0 ? "".concat(user.firstName, " ").concat(user.lastName) : user.email;
    });
    var defaultPadding = computed(function () {
      return props.padding !== 0 ? "padding: 0 ".concat(props.padding, "px") : '';
    });
    function setOrganizers(_x) {
      return _setOrganizers.apply(this, arguments);
    }
    function _setOrganizers() {
      _setOrganizers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(user) {
        var permissions, allOrganizers, organizers;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              permissions = user.permissions || {};
              allOrganizers = Object.keys(permissions).filter(function (org) {
                return permissions[org].org_level || permissions[org].orgLevel;
              });
              _context2.next = 1;
              return Promise.all(allOrganizers.map(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(org) {
                  return regeneratorRuntime.wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 1;
                        return sdk.account.getOrganizer({
                          id: org
                        });
                      case 1:
                        return _context.abrupt("return", _context.sent);
                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 1:
              organizers = _context2.sent;
              organizers = organizers.filter(function (o) {
                return canAccessDashboard.value(mainOrganizer, o.name);
              });
              appStore.setOrganizers(organizers);
              appStore.setOrganizer(organizers[0]);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _setOrganizers.apply(this, arguments);
    }
    function unImpersonate() {
      return _unImpersonate.apply(this, arguments);
    }
    function _unImpersonate() {
      _unImpersonate = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var user, _t;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              appStore.setLoading(true);
              _context3.next = 1;
              return services.account.stopImpersonate();
            case 1:
              user = _context3.sent;
              userStore.setUser(user);
              _context3.next = 2;
              return setOrganizers(user);
            case 2:
              window.location.href = '/manage-accounts';
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t = _context3["catch"](0);
              notifier.showMessage({
                content: errorMessage(_t, t('errors.genericRequest')),
                type: 'error'
              });
            case 4:
              _context3.prev = 4;
              appStore.setLoading(false);
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 3, 4, 5]]);
      }));
      return _unImpersonate.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      appStore: appStore,
      userStore: userStore,
      sdk: sdk,
      services: services,
      notifier: notifier,
      t: t,
      mainOrganizer: mainOrganizer,
      canAccessDashboard: canAccessDashboard,
      getUser: getUser,
      impersonatedUser: impersonatedUser,
      defaultPadding: defaultPadding,
      setOrganizers: setOrganizers,
      unImpersonate: unImpersonate
    };
  }
});